import api from '@mint-lib/api';
import { useMutation, useQueryClient } from '@mint-lib/query-client';
import { getRouteApi } from '@mint/routing';

import { QueryKey } from '../constants/queryKeys.js';
import {
  BuyingPlanLiteSchema,
  UpdateBuyingPlanNamePayload,
  type BuyingPlanLite,
} from '../types/buyingPlan.js';

const updateBuyingPlanName = async (
  payload: UpdateBuyingPlanNamePayload & { campaignId: number },
) => {
  const { buyingPlanId, buyingPlanName, campaignId } = payload;
  const response = await api.put(
    `api/datintell/v1/builder/media_plans/${buyingPlanId}/`,
    {
      name: buyingPlanName,
      campaignCollection: campaignId,
    },
  );

  return BuyingPlanLiteSchema.parse(response.data);
};

const routeApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);
const useBuyingPlanNameMutation = () => {
  const params = routeApi.useParams();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (payload: UpdateBuyingPlanNamePayload) =>
      updateBuyingPlanName({
        ...payload,
        campaignId: Number(params.campaignId),
      }),
    onSuccess: (updatedPlan) => {
      queryClient.setQueryData<BuyingPlanLite[]>(
        [QueryKey.BUYING_PLAN_LIST, params.campaignId],
        (oldData) => {
          return oldData
            ? oldData.map((plan) =>
                plan.id === updatedPlan.id ? updatedPlan : plan,
              )
            : oldData;
        },
      );
    },
  });

  return mutation.mutateAsync;
};

export default useBuyingPlanNameMutation;
